import React from 'react';
import { Grid, Typography, Link } from '@material-ui/core';

const Simple = (props) => {
  const {
    heading = 'No heading',
    accessor = {},
    headingProps = { variant: 'h5', color: 'primary', gutterBottom: true },
    listDirection = 'column',
    list = [],
    listItemProps = {
      variant: 'body2',
      color: 'textPrimary',
      component: 'button',
      gutterBottom: true,
    },
    onClick = () => {},
  } = props;
  return (
    <div>
      <Typography {...headingProps}>{heading}</Typography>
      <Grid
        container
        direction={listDirection}
        alignItems="flex-start"
        spacing={1}
      >
        {list.map((item, index) => {
          return (
            <Grid item>
              <Link
                {...listItemProps}
                onClick={() => onClick(item)}
                style={{ textAlign: 'left', outline: 0 }}
                key={index}
              >
                {item[accessor.label]}
              </Link>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};

export default Simple;
